module.exports = __webpack_public_path__ + "static/img/p_01.d6c54d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_01.png
// module id = 604
// module chunks = 1